'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var Wix = require('wix-sdk');

var _require = require('./utils'),
    addTimeout = _require.addTimeout,
    createSafeCall = _require.createSafeCall;

var WixSdk = exports.WixSdk = function () {
  var errorLogger = function errorLogger(ex) {
    if (global.console && typeof global.console.error === 'function') {
      console.error(ex);
    }
  };

  if (!Wix) {
    errorLogger(new Error('Wix Sdk is missing'));
    return null;
  }

  var safeCall = createSafeCall(function (ex) {
    errorLogger(ex);
  });

  var WixSdk = {
    valid: false,
    config: {
      setErrorLogger: function setErrorLogger(handler) {
        errorLogger = handler;
      }
    },
    Activities: {
      Type: Wix.Activities.Type,
      Error: Wix.Activities.Error,
      postActivity: function postActivity(activity) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.postActivity(activity, resolve, reject);
        }));
      },
      getActivities: function getActivities(query) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.getActivities(resolve, reject, query);
        }));
      },
      getActivityById: function getActivityById(id) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Activities.getActivityById(id, resolve, reject);
        }));
      },
      getUserSessionToken: function getUserSessionToken() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Activities.getUserSessionToken(resolve);
        }));
      }
    },
    Analytics: {
      PixelType: Wix.Analytics.PixelType,
      PixelEventType: Wix.Analytics.PixelEventType,
      registerCampaignPixel: Wix.Analytics.registerCampaignPixel,
      reportCampaignEvent: Wix.Analytics.reportCampaignEvent
    },
    Billing: {
      Cycle: Wix.Billing.Cycle,
      openBillingPageForProduct: function openBillingPageForProduct(vendorProductId, cycle) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.openBillingPageForProduct(vendorProductId, cycle, reject);
        }));
      },
      getBillingPageForProduct: function getBillingPageForProduct(vendorProductId, cycle) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getBillingPageForProduct(vendorProductId, cycle, resolve, reject);
        }));
      },
      getBillingPackages: function getBillingPackages(vendorProductIds) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getBillingPackages(vendorProductIds, resolve, reject);
        }));
      },
      getProducts: function getProducts(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Billing.getProducts(options, resolve, reject);
        }));
      }
    },
    Contacts: {
      getContacts: function getContacts(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.getContacts(options, resolve, reject);
        }));
      },
      getContactById: function getContactById(id) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.getContactById(id, resolve, reject);
        }));
      },
      reconcileContact: function reconcileContact(contactInfo) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Contacts.reconcileContact(contactInfo, resolve, reject);
        }));
      }
    },
    Dashboard: {
      PremiumIntent: Wix.Dashboard.PremiumIntent,
      setHeight: Wix.Dashboard.setHeight,
      openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
        return new Promise(function (resolve) {
          Wix.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
        });
      },

      openBillingPage: Wix.Dashboard.openBillingPage,
      openModal: function openModal(url, width, height) {
        return new Promise(function (resolve) {
          Wix.Dashboard.openModal(url, width, height, resolve);
        });
      },

      closeWindow: Wix.Dashboard.closeWindow,
      scrollTo: Wix.Dashboard.scrollTo,
      getEditorUrl: function getEditorUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Dashboard.getEditorUrl(resolve);
        }));
      },

      pushState: Wix.Dashboard.pushState,
      resizeWindow: Wix.Dashboard.resizeWindow,
      revalidateSession: function revalidateSession() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Dashboard.revalidateSession(resolve, reject);
        }));
      },
      getProducts: function getProducts() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Dashboard.getProducts(resolve, reject);
        }));
      },
      getSiteViewUrl: function getSiteViewUrl(options) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Dashboard.getSiteViewUrl(options, resolve);
        }));
      },

      appEngaged: Wix.Dashboard.appEngaged
    },
    Error: Wix.Error,
    Events: Wix.Events,
    Features: {
      Types: Wix.Features.Types,
      isSupported: function isSupported(featureName) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Features.isSupported(featureName, resolve);
        }));
      }
    },
    Media: {
      AudioType: Wix.Media.AudioType,
      getImageUrl: Wix.Media.getImageUrl,
      getResizedImageUrl: Wix.Media.getResizedImageUrl,
      getAudioUrl: Wix.Media.getAudioUrl,
      getDocumentUrl: Wix.Media.getDocumentUrl,
      getSwfUrl: Wix.Media.getSwfUrl,
      getPreviewSecureMusicUrl: Wix.Media.getPreviewSecureMusicUrl
    },
    PubSub: {
      unsubscribe: Wix.PubSub.unsubscribe,
      subscribe: Wix.PubSub.subscribe,
      publish: Wix.PubSub.publish
    },
    Preview: {
      openSettingsDialog: Wix.Preview.openSettingsDialog
    },
    Settings: {
      MediaType: Wix.Settings.MediaType,
      PremiumIntent: Wix.Settings.PremiumIntent,
      getColorByreference: Wix.Settings.getColorByreference,
      setBooleanParam: Wix.Settings.setBooleanParam,
      setColorParam: Wix.Settings.setColorParam,
      setNumberParam: Wix.Settings.setNumberParam,
      getSiteColors: function getSiteColors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteColors(resolve);
        }));
      },

      getStyleColorByKey: Wix.Settings.getStyleColorByKey,
      getWindowPlacement: function getWindowPlacement(compId) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getWindowPlacement(compId, resolve);
        }));
      },
      getDashboardAppUrl: function getDashboardAppUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getDashboardAppUrl(resolve);
        }));
      },
      getSiteInfo: function getSiteInfo() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteInfo(resolve);
        }));
      },
      getSitePages: function getSitePages(options) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSitePages(options, resolve);
        }));
      },
      getSiteMap: function getSiteMap() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getSiteMap(resolve);
        }));
      },
      getStyleParams: function getStyleParams() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getStyleParams(resolve);
        }));
      },

      openBillingPage: Wix.Settings.openBillingPage,
      appEngaged: Wix.Settings.appEngaged,
      openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
        return new Promise(function (resolve) {
          Wix.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
        });
      },

      openSiteMembersSettingsDialog: Wix.Settings.openSiteMembersSettingsDialog,
      refreshApp: Wix.Settings.refreshApp,
      refreshAppByCompIds: Wix.Settings.refreshAppByCompIds,
      setWindowPlacement: Wix.Settings.setWindowPlacement,
      triggerSettingsUpdatedEvent: Wix.Settings.triggerSettingsUpdatedEvent,
      openModal: function openModal(url, width, height, title, bareUI) {
        return new Promise(function (resolve) {
          Wix.Settings.openModal(url, width, height, title, resolve, bareUI);
        });
      },

      closeWindow: Wix.Settings.closeWindow,
      addComponent: function addComponent(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.addComponent(options, resolve, reject);
        }));
      },
      resizeComponent: function resizeComponent(options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.resizeComponent(options, resolve, reject);
        }));
      },
      setExternalId: function setExternalId(guid) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.setExternalId(guid, resolve, reject);
        }));
      },
      revalidateSession: function revalidateSession() {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.revalidateSession(resolve, reject);
        }));
      },
      getCurrentPageAnchors: function getCurrentPageAnchors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getCurrentPageAnchors(resolve);
        }));
      },
      setFullWidth: function setFullWidth(shouldBeFullWidth, options) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Settings.setFullWidth(shouldBeFullWidth, options, resolve, reject);
        }));
      },
      isFullWidth: function isFullWidth() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.isFullWidth(resolve);
        }));
      },

      openReviewInfo: Wix.Settings.openReviewInfo,
      getStateUrl: function getStateUrl(sectionId, state) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.getStateUrl(sectionId, state, resolve);
        }));
      },
      isComponentInstalled: function isComponentInstalled(componentId) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Settings.isComponentInstalled(componentId, resolve);
        }));
      },
      openLinkPanel: function openLinkPanel(options, onCacnel) {
        return new Promise(function (resolve) {
          Wix.Settings.openLinkPanel(options, resolve, onCacnel);
        });
      }
    },
    Styles: {
      getStyleParams: function getStyleParams() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getStyleParams(resolve);
        }));
      },
      setStyleParams: function setStyleParams(styleObjArr) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setStyleParams(styleObjArr, resolve, reject);
        }));
      },
      setFontParam: function setFontParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setFontParam(key, value, resolve, reject);
        }));
      },
      getEditorFonts: function getEditorFonts() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getEditorFonts(resolve);
        }));
      },
      getSiteTextPresets: function getSiteTextPresets() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getSiteTextPresets(resolve);
        }));
      },
      getFontsSpriteUrl: function getFontsSpriteUrl() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getFontsSpriteUrl(resolve);
        }));
      },

      getStyleFontByKey: Wix.Styles.getStyleFontByKey,
      getStyleFontByReference: Wix.Styles.getStyleFontByReference,
      getSiteColors: function getSiteColors() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getSiteColors(resolve);
        }));
      },

      getStyleColorByKey: Wix.Styles.getStyleColorByKey,
      getColorByreference: Wix.Styles.getColorByreference,
      setColorParam: function setColorParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setColorParam(key, value, resolve, reject);
        }));
      },
      setNumberParam: function setNumberParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setNumberParam(key, value, resolve, reject);
        }));
      },
      setBooleanParam: function setBooleanParam(key, value) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.setBooleanParam(key, value, resolve, reject);
        }));
      },
      openColorPicker: function openColorPicker(params) {
        return new Promise(function (resolve) {
          Wix.Styles.openColorPicker(params, resolve);
        });
      },
      openFontPicker: function openFontPicker(params) {
        return new Promise(function (resolve) {
          Wix.Styles.openFontPicker(params, resolve);
        });
      },

      setUILIBParamValue: Wix.Styles.setUILIBParamValue,
      getStyleId: function getStyleId() {
        return addTimeout(new Promise(function (resolve) {
          Wix.Styles.getStyleId(resolve);
        }));
      },
      getStyleParamsByStyleId: function getStyleParamsByStyleId(styleId) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.Styles.getStyleParamsByStyleId(styleId, resolve, reject);
        }));
      }
    },
    Theme: Wix.Theme,
    Utils: {
      getViewMode: safeCall(Wix.Utils.getViewMode),
      toWixDate: safeCall(Wix.Utils.toWixDate),
      getCompId: safeCall(Wix.Utils.getCompId),
      getOrigCompId: safeCall(Wix.Utils.getOrigCompId),
      getWidth: safeCall(Wix.Utils.getWidth),
      getLocale: safeCall(Wix.Utils.getLocale),
      getCacheKiller: safeCall(Wix.Utils.getCacheKiller),
      getTarget: safeCall(Wix.Utils.getTarget),
      getSectionUrl: function getSectionUrl(sectionIdentifier) {
        return addTimeout(new Promise(function (resolve) {
          Wix.Utils.getSectionUrl(sectionIdentifier, resolve);
        }));
      },

      getInstanceId: safeCall(Wix.Utils.getInstanceId),
      getSignDate: safeCall(Wix.Utils.getSignDate),
      getUid: safeCall(Wix.Utils.getUid),
      getPermissions: safeCall(Wix.Utils.getPermissions),
      getIpAndPort: safeCall(Wix.Utils.getIpAndPort),
      getDemoMode: safeCall(Wix.Utils.getDemoMode),
      getDeviceType: safeCall(Wix.Utils.getDeviceType),
      getInstanceValue: safeCall(Wix.Utils.getInstanceValue),
      navigateToSection: safeCall(Wix.Utils.navigateToSection),
      getSiteOwnerId: safeCall(Wix.Utils.getSiteOwnerId),
      Media: {
        AudioType: Wix.Utils.Media.AudioType,
        getImageUrl: Wix.Utils.Media.getImageUrl,
        getResizedImageUrl: Wix.Utils.Media.getResizedImageUrl,
        getAudioUrl: Wix.Utils.Media.getAudioUrl,
        getDocumentUrl: Wix.Utils.Media.getDocumentUrl,
        getSwfUrl: Wix.Utils.Media.getSwfUrl,
        getPreviewSecureMusicUrl: Wix.Utils.Media.getPreviewSecureMusicUrl
      }
    },
    Data: {
      SCOPE: Wix.Data.SCOPE,
      Public: {
        set: function set(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.set(key, value, options, resolve, reject);
          }));
        },
        get: function get(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.get(key, options, resolve, reject);
          }));
        },
        remove: function remove(key, value, options) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.Data.Public.remove(key, options, resolve, reject);
          }));
        }
      }
    },
    Performance: {
      applicationLoaded: Wix.Performance.applicationLoaded,
      applicationLoadingStep: Wix.Performance.applicationLoadingStep
    },
    WindowOrigin: Wix.WindowOrigin,
    WindowPlacement: Wix.WindowPlacement,
    openModal: function openModal(url, width, height, theme) {
      return new Promise(function (resolve) {
        Wix.openModal(url, width, height, resolve, theme);
      });
    },
    openPopup: function openPopup(url, width, height, position, theme) {
      return new Promise(function (resolve) {
        Wix.openPopup(url, width, height, position, resolve, theme);
      });
    },

    setHeight: Wix.setHeight,
    closeWindow: Wix.closeWindow,
    scrollTo: Wix.scrollTo,
    scrollBy: Wix.scrollBy,
    getSiteInfo: function getSiteInfo() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSiteInfo(resolve);
      }));
    },
    getSitePages: function getSitePages(options) {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSitePages(options, resolve);
      }));
    },
    getSiteMap: function getSiteMap() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getSiteMap(resolve);
      }));
    },
    getBoundingRectAndOffsets: function getBoundingRectAndOffsets() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getBoundingRectAndOffsets(resolve);
      }));
    },

    removeEventListener: Wix.removeEventListener,
    addEventListener: Wix.addEventListener,
    resizeWindow: Wix.resizeWindow,
    requestLogin: function requestLogin(options, onCancel) {
      return new Promise(function (resolve) {
        Wix.requestLogin(options, resolve, onCancel);
      });
    },
    logOutCurrentMember: function logOutCurrentMember(options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.logOutCurrentMember(options, reject);
      }));
    },
    currentMember: function currentMember() {
      return addTimeout(new Promise(function (resolve) {
        Wix.currentMember(resolve);
      }));
    },
    navigateTo: function navigateTo(linkData) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateTo(linkData, reject);
      }));
    },
    navigateToPage: function navigateToPage(pageId, options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToPage(pageId, options, reject);
      }));
    },
    getCurrentPageId: function getCurrentPageId() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getCurrentPageId(resolve);
      }));
    },

    pushState: Wix.pushState,
    reportHeightChange: Wix.reportHeightChange,
    getStyleParams: function getStyleParams() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getStyleParams(resolve);
      }));
    },
    getExternalId: function getExternalId() {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.getExternalId(resolve, reject);
      }));
    },
    navigateToComponent: function navigateToComponent(compId, options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToComponent(compId, options, reject);
      }));
    },
    resizeComponent: function resizeComponent(options) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.resizeComponent(options, resolve, reject);
      }));
    },
    revalidateSession: function revalidateSession() {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.revalidateSession(resolve, reject);
      }));
    },
    getCurrentPageAnchors: function getCurrentPageAnchors() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getCurrentPageAnchors(resolve);
      }));
    },
    navigateToAnchor: function navigateToAnchor(anchorId) {
      return addTimeout(new Promise(function (resolve, reject) {
        Wix.navigateToAnchor(anchorId, reject);
      }));
    },
    getComponentInfo: function getComponentInfo() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getComponentInfo(resolve);
      }));
    },

    replaceSectionState: Wix.replaceSectionState,
    setPageMetadata: Wix.setPageMetadata,
    getStateUrl: function getStateUrl(sectionId, state) {
      return addTimeout(new Promise(function (resolve) {
        Wix.getStateUrl(sectionId, state, resolve);
      }));
    },
    getAdsOnPage: function getAdsOnPage() {
      return addTimeout(new Promise(function (resolve) {
        Wix.getAdsOnPage(resolve);
      }));
    }
  };

  if (Wix.SuperApps) {
    WixSdk = _extends({}, WixSdk, {
      SuperApps: {
        Settings: {
          MediaType: Wix.SuperApps.Settings.MediaType,
          openBillingPage: Wix.SuperApps.Settings.openBillingPage,
          getInstalledInstance: function getInstalledInstance(appDefinitionId) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Settings.getInstalledInstance(appDefinitionId, resolve, reject);
            }));
          },
          openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Settings.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
            });
          },
          openModal: function openModal(url, width, height, title, bareUI, options) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Settings.openModal(url, width, height, title, resolve, bareUI, options);
            });
          },

          setHelpArticle: Wix.SuperApps.Settings.setHelpArticle
        },
        Dashboard: {
          showHeader: Wix.SuperApps.Dashboard.showHeader,
          hideHeader: Wix.SuperApps.Dashboard.hideHeader,
          setHelpArticle: Wix.SuperApps.Dashboard.setHelpArticle,
          getProducts: function getProducts(options) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Dashboard.getProducts(options, resolve, reject);
            }));
          },
          openMediaDialog: function openMediaDialog(mediaType, multipleSelection, onCancel) {
            return new Promise(function (resolve) {
              Wix.SuperApps.Dashboard.openMediaDialog(mediaType, multipleSelection, resolve, onCancel);
            });
          }
        },
        getInstalledInstance: function getInstalledInstance(appDefinitionId) {
          return addTimeout(new Promise(function (resolve, reject) {
            Wix.SuperApps.getInstalledInstance(appDefinitionId, resolve, reject);
          }));
        },

        OnBoarding: {
          Settings: {
            getStyleByCompId: function getStyleByCompId(compId) {
              return addTimeout(new Promise(function (resolve) {
                Wix.SuperApps.OnBoarding.Settings.getStyleByCompId(compId, resolve);
              }));
            }
          }
        },
        Billing: {
          getProducts: function getProducts(options) {
            return addTimeout(new Promise(function (resolve, reject) {
              Wix.SuperApps.Billing.getProducts(options, resolve, reject);
            }));
          }
        },
        getCtToken: function getCtToken() {
          return addTimeout(new Promise(function (resolve) {
            Wix.SuperApps.getCtToken(resolve);
          }));
        }
      },
      getInstalledInstance: function getInstalledInstance(appDefinitionId) {
        return addTimeout(new Promise(function (resolve, reject) {
          Wix.getInstalledInstance(appDefinitionId, resolve, reject);
        }));
      },

      OnBoarding: {
        Settings: {
          getStyleByCompId: function getStyleByCompId(compId) {
            return addTimeout(new Promise(function (resolve) {
              Wix.OnBoarding.Settings.getStyleByCompId(compId, resolve);
            }));
          }
        }
      },
      getCtToken: function getCtToken() {
        return addTimeout(new Promise(function (resolve) {
          Wix.getCtToken(resolve);
        }));
      }
    });
  }
  return WixSdk;
}();
//# sourceMappingURL=wix-sdk-wrapper.js.map



//////////////////
// WEBPACK FOOTER
// ../~/js-sdk-wrapper/dist/src/wix-sdk-wrapper.js
// module id = 0
// module chunks = 9 10 11